import { render, staticRenderFns } from "./TeacherTypeCard.vue?vue&type=template&id=4bff8c18&scoped=true&"
import script from "./TeacherTypeCard.vue?vue&type=script&lang=js&"
export * from "./TeacherTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherTypeCard.vue?vue&type=style&index=0&id=4bff8c18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bff8c18",
  null
  
)

export default component.exports